import { connect } from 'react-redux';

import { GroupsHeader, IGroupsHeaderStoreProps } from '.';
import { IAppState } from '../../../../store';

function mapStateToProps(state: IAppState): IGroupsHeaderStoreProps {
  const email = state.user.email || null;

  return {
    email,
  };
}

export const GroupsHeaderContainer = connect<IGroupsHeaderStoreProps, {}, {}>(mapStateToProps)(GroupsHeader);
